import React, { Component } from 'react';
import {BrowserRouter as Router} from 'react-router-dom';
import * as Constants from '../../../common/Global/constants';
import {TableCheckBox,CustomTableRow,AddNewButtonLayout,
    DialogSaveButton,DialogProceedButton,TableRadioButton} from '../../../common/Global/globalStyles.style';
import {getLocalStorageVariables,getThemeSettingsVariables,isEmptyVariable,
    removeHtmlTags,isEmptyArray, getStatusSpan,
    handleTokenExpiry, getClientResponseDeadlineBadge} from '../../../common/Global/commonFunctions';
import {Accordion, Button, Card, Modal} from 'react-bootstrap';
import FilterDropDown from "../../../common/DropdownMenus/FilterDropdown";
import AlertDialog from '../../../common/AlertDialog';
import { DatePicker } from 'antd';
import moment from 'moment';
import { AsyncPaginate } from 'react-select-async-paginate';

let userDetails = getLocalStorageVariables();
let themeSettings = getThemeSettingsVariables();
const resourceDropdownPlaceholder="Select Employee";

class AssignForResponse extends Component {
    constructor(props) {
        super(props);
        this.state = {
            componentDidMountFlag:false,
            datalist:[],
            showLoader:false,

            employeesList:[],
            functionMap:[],

            showAlertDialogInfo:false,
            alertDialogMessageInfo:"",

            showAssignResourcesDialogFlag:false,
            resourceDropdownPlaceholder:"Select Employee",

            showResponseWarningDialog:false,
            responseWarningMessage:"",
            showResourceResponseWarningDialog:false,
            resourceResponseWarningMessage:"",

            filterDataList: [],
            FilterDropDownArr: [],
            FilterPlaceholder: "All",

            assigneResourcesFilterDropDownArr :[],
            assigneResourcesFilterDataList:[],
            assignResourcesPlaceholder:"All",
            activeKey: null,
            activeAssignResourceKey: null,

            selectedEmployee:null,
            employeeSelectKey:0
        }
        userDetails = getLocalStorageVariables();
        themeSettings = getThemeSettingsVariables();
    }

    debounceTimers = { employee: null };

    componentDidMount(){
        this.getInitData();
    }

    componentDidUpdate(prevProps){
        if(JSON.stringify(prevProps) !== JSON.stringify(this.props)){
            this.setState({
                componentDidMountFlag:true,
                datalist:[],
                showLoader:true,
                employeesList:[],
                functionMap:[],

                showAlertDialogInfo:false,
                alertDialogMessageInfo:"",

                // addErrors:{},
                showProcessFunctionsDialog:false,
                resourceDropdownPlaceholder:"Select Employee",
            })
        }
    }

    getRootLevelFunctions = (functionMapTemp) => {
        let rootFunctionArr = [];
        Object.values(functionMapTemp).map((item)=>{
            if(item.level === 0){
                rootFunctionArr.push(item);
            }
        })
        return rootFunctionArr;
    }

    //No need of return value since the array itself is passed and updated.
    addParentIdandHasChildrenFlag = (tempArr, processId, parentProcessId, parentProcessBreadCrumb) => {
        tempArr[processId].parentProcessId = parentProcessId;
        let breadCrumb = "";
        if(isEmptyVariable(parentProcessBreadCrumb)){
            breadCrumb = tempArr[processId].processName;
            tempArr[processId].breadCrumb = breadCrumb;
        }else{
            breadCrumb = parentProcessBreadCrumb + " > " + tempArr[processId].processName;
            tempArr[processId].breadCrumb = breadCrumb;
        }

        if(!isEmptyArray(tempArr[processId].children)){
            tempArr[processId].hasChildren = true;

            tempArr[processId].children.map(childNode => {
                this.addParentIdandHasChildrenFlag(tempArr,childNode.processId,processId,breadCrumb);
            });
        }else{
            tempArr[processId].hasChildren = false;
        }
    }

    handleStopPropagation = (e) => {
        e.stopPropagation();
    }

    // Tasks to Assignment Selection
    handleSelectionTask = (e) => {
        e.stopPropagation();
        let isChecked = e.target.checked;
        let indexAndProcessId = e.target.name;
        let iapArr = indexAndProcessId.split(":-:")
        let index = iapArr[0];
        let processId = iapArr[1];
        let list = this.state.datalist;

        //now select/unselect the task
        if(!list[processId].taskList[index].disabled){
            list[processId].taskList[index].isSelected = isChecked;
        }

        //check whether all the selectable tasks with in proc are selected
        let atleastOneNotSelected = list[processId].taskList.some(item => !item.disabled && !item.isSelected)
        list[processId].isProcSelected = !atleastOneNotSelected;

        this.setState({
            datalist:list
        });
    }

    handleSelectionProcessTasks = (e) => {
        e.stopPropagation();
        let isChecked = e.target.checked;
        let processId = e.target.name;
        let list = this.state.datalist;

        // also select all the selectable tasks
        let newTasklist = list[processId].taskList.map(item=>{
            if(!item.disabled){
                item.isSelected = isChecked
            }
            return item;
        })
        list[processId].taskList = newTasklist;
        list[processId].isProcSelected = newTasklist.every(item => item.disabled || item.isSelected === true);
        this.setState({
            datalist:list
        });
    }

    selectAll = () => {
        let newDataList = {};
        for (const [key, value] of Object.entries(this.state.datalist)) {
            let newValue = value;
            let newTaskList = value.taskList.map(item=>{
                if(!item.disabled){
                    item.isSelected = true;
                }
                return item;
            })
            newValue.taskList = newTaskList;
            newValue.isProcSelected = newTaskList.every(item => item.disabled || item.isSelected === true);
            newDataList[key] = newValue;
        }
        this.setState({
            datalist:newDataList
        })
    }

    unSelectAll = () => {
        let newDataList = {};
        for (const [key, value] of Object.entries(this.state.datalist)) {
            let newValue = value;
            newValue.isProcSelected = false;
            let newTaskList = value.taskList.map(item=>{
                item.isSelected = false;
                return item;
            })
            newValue.taskList = newTaskList;
            newDataList[key] = newValue;
        }
        this.setState({
            datalist:newDataList
        })
    }

    onClickAddToAssignment = () => {
        let warningTaskNames = [];
        for (const value of Object.values(this.state.datalist)) {
            value.taskList.forEach(item => {
                if(item.isSelected && item.showResponseWarning){
                    warningTaskNames.push(removeHtmlTags(item.task));
                }
            })
        }

        if(warningTaskNames.length > 0){
            this.setState({
                showResponseWarningDialog:true,
                responseWarningMessage:"Response for the below tasks has been received. Do you again want to submit it for the client's response?<br/><br/><b>"
                    +warningTaskNames.map(name => "&bull;&nbsp;"+name).join("<br/>")+"</b>"
            })
        }else{
            this.addSelectedToAssignment();
        }
    }

    addSelectedToAssignment = () => {
        let newDataList = {};
        for (const [key, value] of Object.entries(this.state.datalist)) {
            let newValue = value;
            let newTaskList = value.taskList.map(item=>{
                if(item.isSelected){
                    item.added = true;
                }
                return item;
            })
            newValue.taskList = newTaskList;
            newDataList[key] = newValue;
        }
        this.setState({
            datalist:newDataList,
            showResponseWarningDialog:false
        })
    }

    handleResponseWarningDialogClose = () => {
        let newDataList = {};
        for (const [key, value] of Object.entries(this.state.datalist)) {
            let newValue = value;
            let newTaskList = value.taskList.map(item=>{
                if(item.isSelected && item.showResponseWarning){
                    item.isSelected = false;
                }
                return item;
            })
            newValue.taskList = newTaskList;
            newValue.isProcSelected = newTaskList.every(item => item.disabled || item.isSelected === true);
            newDataList[key] = newValue;
        }
        this.setState({
            datalist:newDataList,
            showResponseWarningDialog:false
        })
    }

    onClickRemoveFromAssignment = () => {
        let newDataList = {};
        for (const [key, value] of Object.entries(this.state.datalist)) {
            let newValue = value;
            let newTaskList = value.taskList.map(item=>{
                if(item.isSelected){
                    item.added = false;
                }
                return item;
            })
            newValue.taskList = newTaskList;
            newDataList[key] = newValue;
        }
        this.setState({
            datalist:newDataList
        })
    }

    handleAccordionToggle = (eventKey) => {
        if (this.state.activeKey === eventKey) {
            this.setState({ activeKey: null });
        } else {
            this.setState({ activeKey: eventKey });
        }
    }

    handleAccordionToggleAssignResource = (eventKey) => {
        if (this.state.activeAssignResourceKey === eventKey) {
            this.setState({ activeAssignResourceKey: null });
        } else {
            this.setState({ activeAssignResourceKey: eventKey });
        }
    }

    filterDropDownOnClick = (selectedItem) =>{
        let tempFilterDataList =[];
        let tempFilterDataArray = this.state.FilterDropDownArr;
        if(selectedItem.label==="All"){
            this.setState({
                filterDataList:[],
            })
        }else{
            Object.values(this.state.datalist).map((item)=>{
                if(selectedItem.label === item.processName){
                    tempFilterDataList.push(item)
                }
            })
        }
        tempFilterDataArray.map((item) => {
            if (item.label === selectedItem.label) {
                item.isSelected = true;
            } else {
                item.isSelected = false;
            }
        });

        this.setState({
            filterDataList:tempFilterDataList,
            FilterDropDownArr:tempFilterDataArray,
            FilterPlaceholder:selectedItem.label
        })
    }

    handleAlertDialogCloseInfo = () => {
        this.setState({
            showAlertDialogInfo:false,
            alertDialogMessageInfo:""
        })
    }

    resourceDropdownClick = (resource) => {
        let newDataList = {};
        let resourceCount = 0;
        for (const [key, value] of Object.entries(this.state.datalist)) {
            let newValue = value;
            let newTaskList = value.taskList.map(item=>{
                if(item.isEmployeeTaskSelected){
                    item.addedEmployeeToAssignment = true;
                    item.employeeId = resource.employeeId;
                    item.employeeFullName = resource.fullName;
                    item.employeeType = resource.employeeType;
                    resourceCount += 1;
                }
                return item;
            })
            newValue.isProcSelectedInResources = false;
            newTaskList = value.taskList.map(item=>{
                item.isEmployeeTaskSelected = false;
                return item;
            })
            newValue.taskList = newTaskList;
            newDataList[key] = newValue;
        }
        if(resourceCount>0){
            this.setState({
                showAlertDialogInfo:true,
                alertDialogMessageInfo:`${resourceCount} tasks have been allocated to ${resource.fullName}`,
            })
        }
        this.setState({
            datalist:newDataList,
            resourceCount:resourceCount,
            selectedEmployee:null,
            employeeSelectKey: this.state.employeeSelectKey + 1
        })
    }

    getEmployeesList = (inputValue) => {
        clearTimeout(this.debounceTimers.employee);
        return new Promise((resolve) => {
            if (!inputValue || inputValue.length < 3) {
                resolve({ options:[], hasMore:false });
                return;
            }
            this.debounceTimers.employee = setTimeout(() => {
                fetch(Constants.EmployeeOrAuditeeList,{
                    method:"POST",
                    mode:'cors',
                    body: new URLSearchParams({
                        email:userDetails.email,
                        accessToken:userDetails.accessToken,
                        search:inputValue,
                        assignmentId:this.props.assignmentId
                    })
                })
                .then(response => response.json())
                .then(data => {
                    if(handleTokenExpiry(data.responseCode)){
                        resolve({ options:[] });
                        return;
                    }
                    if(data.responseCode === Constants.CODE_SUCCESS){
                        const draftAssignmentAuditeeList = data.data.draftAssignmentAuditeeList || [];
                        const clientEmployeeList = data.data.clientEmployeeList || [];

                        const markedAuditees = draftAssignmentAuditeeList.map(emp => ({
                            ...emp,
                            isAuditee:true,
                            fullName:`${emp.firstName} ${emp.lastName} (${emp.designation})`
                        }));
                        const regularEmployees = clientEmployeeList.map(emp => ({
                            ...emp,
                            isAuditee:false,
                            fullName:`${emp.firstName} ${emp.lastName} (${emp.designation})`
                        }));
                        resolve({ options:[...markedAuditees, ...regularEmployees], hasMore:false });
                    } else {
                        resolve({ options:[] });
                    }
                })
                .catch(() => resolve({ options:[] }));
            }, 300);
        });
    }

    handleEmployeeSelect = (selectedEmp) => {
        this.setState({ selectedEmployee:selectedEmp });
        this.resourceDropdownClick(selectedEmp);
    }

    handleSelectionTaskInResourcesDialog = (e) => {
        e.stopPropagation();

        let isChecked = e.target.checked;
        let indexAndProcessId = e.target.name;
        let iapArr = indexAndProcessId.split(":-:")
        let index = iapArr[0];
        let processId = iapArr[1];
        let list = this.state.datalist;
        let triggeredWarningName = null;

        if(!list[processId].taskList[index].disabled){
            list[processId].taskList[index].isEmployeeTaskSelected = isChecked;
            if(isChecked && list[processId].taskList[index].showResponseWarning){
                triggeredWarningName = removeHtmlTags(list[processId].taskList[index].task);
            }
        }

        //check whether all the selectable tasks with in proc are selected
        let atleastOneNotSelected = list[processId].taskList.some(item => !item.disabled && !item.isEmployeeTaskSelected)
        list[processId].isProcSelectedInResources = !atleastOneNotSelected;

        let newState = { datalist:list };
        if(!isEmptyVariable(triggeredWarningName)){
            newState.showResourceResponseWarningDialog = true;
            newState.resourceResponseWarningMessage = "Response for the below task has been received. Do you again want to submit it for the client's response?<br/><br/><b>&bull;&nbsp;"
                +triggeredWarningName+"</b>";
        }

        this.setState(newState);
    }

    handleResourceResponseWarningDialogClose = () => {
        let newDataList = {};
        for (const [key, value] of Object.entries(this.state.datalist)) {
            let newValue = value;
            let newTaskList = value.taskList.map(item=>{
                if(item.isEmployeeTaskSelected && item.showResponseWarning){
                    item.isEmployeeTaskSelected = false;
                }
                return item;
            })
            newValue.taskList = newTaskList;
            newValue.isProcSelectedInResources = newTaskList.every(item => item.disabled || item.isEmployeeTaskSelected === true);
            newDataList[key] = newValue;
        }
        this.setState({
            datalist:newDataList,
            showResourceResponseWarningDialog:false
        })
    }

    handleResourceResponseWarningConfirm = () => {
        this.setState({
            showResourceResponseWarningDialog:false
        })
    }

    handleSelectionProcessTasksInResourcesDialog = (e) => {
        e.stopPropagation();
        let isChecked = e.target.checked;
        let processId = e.target.name;
        let list = this.state.datalist;

        // also select all the selectable tasks
        let newTasklist = list[processId].taskList.map(item=>{
            if(!item.disabled){
                item.isEmployeeTaskSelected = isChecked
            }
            return item;
        })
        list[processId].taskList = newTasklist;
        list[processId].isProcSelectedInResources = newTasklist.every(item => item.disabled || item.isEmployeeTaskSelected === true);

        this.setState({
            datalist:list
        });
    }

    selectAllTasksResourcesDialog = () => {
        let newDataList = {};
        for (const [key, value] of Object.entries(this.state.datalist)) {
            let newValue = value;
            //when user "selects all" in resource dialog, we should select all the tasks
            //that are added to the assignment and not already locked from reassignment
            let newTaskList = value.taskList.map(item=>{
                item.isEmployeeTaskSelected = (item.added && !item.disabled)?true:false;
                return item;
            })
            newValue.taskList = newTaskList;
            newValue.isProcSelectedInResources = newTaskList.every(item => item.disabled || item.isEmployeeTaskSelected === true);
            newDataList[key] = newValue;
        }
        this.setState({
            datalist:newDataList
        })
    }

    unSelectAllTasksResourcesDialog = () => {
        let newDataList = {};
        for (const [key, value] of Object.entries(this.state.datalist)) {
            let newValue = value;
            newValue.isProcSelectedInResources = false;
            let newTaskList = value.taskList.map(item=>{
                item.isEmployeeTaskSelected = false;
                return item;
            })
            newValue.taskList = newTaskList;
            newDataList[key] = newValue;
        }
        this.setState({
            datalist:newDataList
        })
    }

    assignResourcesDialogClose = () => {
        this.unSelectAllTasksResourcesDialog();
        this.setState({
            datalist:this.state.oldDataList,
            showAssignResourcesDialogFlag:false,
            activeAssignResourceKey:null
        })
    }

    onClickNextButton = () => {

        this.setState({
            showLoader:true
        })

        let isError = true;
        // let formErr = {};
        // formErr.assignTaskErr = "Please add atleast one task to the assignment"

        Object.values(this.state.datalist).map(processObj=>{
            processObj.taskList.map(item=>{
                if(item.added){
                    isError = false;
                    // formErr.assignTaskErr = "";
                }
            })
        })

        let tempFilterArray = [
            {
                label: "All",
                isSelected: true,
            },
        ];

            
        Object.values(this.state.datalist).map((processObj)=>{
            let showTasks=(processObj.taskList).some((item) =>item.added===true);
            if(showTasks){
                tempFilterArray.push({
                    label:this.state.processMap[processObj.processId].processName,
                    isSelected:false
                })
            }
        })

        let oldDataList = JSON.parse(JSON.stringify(this.state.datalist));
        //now do the validation
        if(isError){
            this.setState({
                showLoader:false,
                showAlertDialogInfo:true,
            	alertDialogMessageInfo:"Please add atleast one task to the assignment"
            });
        }else{
            this.setState({
                showAssignResourcesDialogFlag:true,
                showLoader:false,
                oldDataList:oldDataList,
                assigneResourcesFilterDataList:[],
                assigneResourcesFilterDropDownArr:tempFilterArray,
                assignResourcesPlaceholder:"All"
            })
        }
    }

    assigneResourceFilterDropDownOnClick = (selectedItem) =>{
        let tempFilterDataList =[];
        let tempFilterDataArray = this.state.assigneResourcesFilterDropDownArr;
        if(selectedItem.label==="All"){
            this.setState({
                filterDataList:[],
            })
        }else{
            Object.values(this.state.datalist).map((item)=>{
                if(selectedItem.label === item.processName){
                    tempFilterDataList.push(item)
                }
            })
        }
        tempFilterDataArray.map((item) => {
            if (item.label === selectedItem.label) {
                item.isSelected = true;
            } else {
                item.isSelected = false;
            }
        });

        this.setState({
            assigneResourcesFilterDataList:tempFilterDataList,
            assigneResourcesFilterDropDownArr:tempFilterDataArray,
            assignResourcesPlaceholder:selectedItem.label
        })
    }

    onClickAddResourceToAssignment = () => {
        let isError = false;
        let hasSelection = false;
        Object.values(this.state.datalist).forEach(processObj=>{
            processObj.taskList.forEach(item=>{
                if(item.addedEmployeeToAssignment || (item.isEmployeeTaskSelected && !isEmptyVariable(item.employeeId))){
                    hasSelection = true;
                }
                if(item.added && isEmptyVariable(item.employeeId)){
                    isError = true;
                }else{
                    
                }
            })
        })

        if(!hasSelection){
            this.setState({
                showAlertDialogInfo:true,
                alertDialogMessageInfo:"Please select at least one task and assign a resource"
            })
        }else if(isError){
            this.setState({
                showAlertDialogInfo:true,
                alertDialogMessageInfo:"Please add resource to all the tasks"
            })
        }else{
            //now parse the array
            let assignmentTasks = []
            Object.values(this.state.datalist).forEach(processObj=>{
                processObj.taskList.forEach(item=>{
                    if(item.added && !isEmptyVariable(item.employeeId) && (item.addedEmployeeToAssignment || item.isEmployeeTaskSelected)){
                        let obj = {
                            employeeId:item.employeeId,
                            employeeType:item.employeeType
                        }

                        if(!isEmptyVariable(item.assignmentTaskId)){
                            obj.assignmentTaskId = item.assignmentTaskId;
                        }
                        if(!isEmptyVariable(item.observationId)){
                            obj.observationId = item.observationId;
                        }
                        assignmentTasks.push(obj);
                    }
                })
            })

            this.setState({
                showNextDateDialog:true,
                assignmentTasks:JSON.stringify(assignmentTasks)
            })
        }
    }

    handleDateDialogClose = () => {
        this.setState({
            showNextDateDialog:false,
            assignmentTasks:[]
        })
    }

    handleClear = () => {
        this.setState({
            deadlineDate:null,
            selectedOption:""
        })
    }

    // if onDateChange already exists, replace it; otherwise add this handler
    onDateChange = (date, dateString) => {
        // when user picks a date, clear radio selection so radios become disabled
        this.setState({
            deadlineDate:isEmptyVariable(date)?null:date.format("YYYY-MM-DD")
        })
    }

    handleCheck = (e) =>{
        let selectedOption = e.target.value;
        let FormErrorsTemp = this.state.formErrors;

        if(this.state.submitClickedAtleastOnce){
            FormErrorsTemp['option'] = "";
        }

        this.setState({
            selectedOption
        })
    }

    /*******************API CALLS*******************/
    getInitData = () => {
        this.setState({
            showLoader:true,
        });

        Promise.all([
            fetch(Constants.GetProcessesSubtree,
            {
                method: "POST",
                mode:'cors',
                body: new URLSearchParams({
                    email:userDetails.email,
                    accessToken:userDetails.accessToken,
                    departmentId:this.props.departmentId,
                    status:"ALL",
                    activeFlag:"Y"//get values from active tables
                })
            }),
            fetch(Constants.GetAssignTaskMasterData,
            {
                method: "POST",
                mode:'cors',
                body: new URLSearchParams({
                    email:userDetails.email,
                    accessToken:userDetails.accessToken,
                    assignmentId:this.props.assignmentId,
                })
            }),
            fetch(Constants.GetAssignedTasks,
            {
                method: "POST",
                mode:'cors',
                body: new URLSearchParams({
                    email:userDetails.email,
                    accessToken:userDetails.accessToken,
                    assignmentId:this.props.assignmentId,
                })
            }),
            fetch(Constants.EmployeeOrAuditeeList,{
                method: "POST",
                mode:'cors',
                body: new URLSearchParams({
                    email:userDetails.email,
                    accessToken:userDetails.accessToken,
                    assignmentId:this.props.assignmentId
                })
            }),
            fetch(Constants.GetEmployeeOrAuditee+"/"+this.props.assignmentId,{
                method: "POST",
                mode:'cors',
                body: new URLSearchParams({
                    email:userDetails.email,
                    accessToken:userDetails.accessToken,
                })
            })
        ])
        .then(([masterRes,generalRes,assignedTasksRes,empAudRes,empRes]) => { 
            return Promise.all([masterRes.json(),generalRes.json(),assignedTasksRes.json(),empAudRes.json(),empRes.json()]) 
        })
        .then(([masterRes,generalRes,assignedTasksRes,empAudRes,empRes]) => {
            let processMapTemp = {};
            let datalistTemp = {};
            let assignedTasksMap = {};
            let draftAssignmentAuditeeList = [];
            let clientEmployeeList = [];
            let assignedTasks = [];
            if(handleTokenExpiry(masterRes.responseCode)) return;
            else if(masterRes.responseCode === Constants.CODE_SUCCESS){
                processMapTemp = masterRes.result.processMap;
                
                let rootLevelArr = this.getRootLevelFunctions(processMapTemp);
                for(const [index,value] of rootLevelArr.entries()){
                    this.addParentIdandHasChildrenFlag(processMapTemp, value.processId, value.processId, "");
                }
            }else{
            }

            if(handleTokenExpiry(assignedTasksRes.responseCode)) return;
            else if(assignedTasksRes.responseCode === Constants.CODE_SUCCESS){
                assignedTasks = assignedTasksRes.data.assignedTasks;

                assignedTasks.forEach(item=>{
                    assignedTasksMap[item.taskId] = item;
                })
            }else{
            }

            let employeeData = [];
            if(handleTokenExpiry(empRes.responseCode)) return;
            else if(empRes.responseCode === Constants.CODE_SUCCESS){
                employeeData = empRes.data;
            }else{

            }

            let employeesList = [];
            if(handleTokenExpiry(generalRes.responseCode)) return;
            else if(generalRes.responseCode === Constants.CODE_SUCCESS){
                let datalistTempArr = generalRes.data.taskList;

                datalistTemp = {};
                datalistTempArr.forEach((item)=>{
                    //add only leaf level nodes
                    if(processMapTemp[item.processId] && !processMapTemp[item.processId].hasChildren){
                        let updatedTaskList = [];
                        item.taskList.forEach(task=>{
                            if(!isEmptyVariable(assignedTasksMap[task.taskId])){
                                task.assigmentTaskStatus = assignedTasksMap[task.taskId].status;
                                task.assignmentTaskId = assignedTasksMap[task.taskId].assignmentTaskId;
                                task.showResponseWarning = assignedTasksMap[task.taskId].showResponseWarning;
                                task.employeeData = employeeData.filter(e => e.assignmentTaskId === task.assignmentTaskId);
                                if(!isEmptyArray(task.employeeData)){
                                    task.added = true;
                                    task.employeeFullName = task.employeeData[0].employeeDetails.firstName + " " + task.employeeData[0].employeeDetails.lastName + " ("+task.employeeData[0].employeeDetails.designation+")";
                                    task.employeeId = task.employeeData[0].employeeDetails.employeeId;
                                    task.employeeType = task.employeeData[0].userType;
                                    task.clientResponseDeadline = task.employeeData[0].clientResponseDeadline;
                                    task.hasAddedResponse = task.employeeData[0].hasAddedResponse;
                                    task.disabled = assignedTasksMap[task.taskId].allowClientReAssign === false;
                                } else {
                                    task.disabled = assignedTasksMap[task.taskId].allowClientReAssign === false;
                                }
                            } else {
                                task.disabled = false;
                            }
                            updatedTaskList.push(task);
                        })
                        item.taskList = updatedTaskList;

                        datalistTemp[item.processId] = item;
                        datalistTemp[item.processId].currentPageNo = 1; //set the current page no as 1 for all the individual task lists
                    }
                })
            }else{
            }

            if(handleTokenExpiry(empAudRes.responseCode)) return;
            else if(empAudRes.responseCode === Constants.CODE_SUCCESS){
                draftAssignmentAuditeeList = empAudRes.data.draftAssignmentAuditeeList;
                clientEmployeeList = empAudRes.data.clientEmployeeList;

                const matchingAssignmentUnit = clientEmployeeList.filter(emp => {
                    const unitId = JSON.parse(emp.unit)[0]; 
                    return this.props.unitListId.includes(unitId);
                });

                const otherEmployees = clientEmployeeList.filter(emp => {
                    const unitId = JSON.parse(emp.unit)[0];
                    return !this.props.unitListId.includes(unitId);
                });

                const finalList = [...matchingAssignmentUnit, ...otherEmployees];

                let employees = [...draftAssignmentAuditeeList,...finalList]
                employeesList = employees.map(emp => ({
                    ...emp,
                    userName: `${emp.firstName} ${emp.lastName}`,
                    fullName:`${emp.firstName} ${emp.lastName} (${emp.designation})`
                }))
            }else{

            }

            let tempFilterArray = [
                {
                  label: "All",
                  isSelected: true,
                },
            ];
            Object.values(datalistTemp).map((processObj)=>{
                tempFilterArray.push({
                    label:processMapTemp[processObj.processId].processName,
                    isSelected:false
                })
            })
            this.setState({
                componentDidMountFlag:true,
                showLoader:false,

                processMap:processMapTemp,
                datalist:datalistTemp,

                FilterDropDownArr:tempFilterArray,
                employeesList:employeesList,
                employeeData:employeeData,
                assignedTasks:assignedTasks
            })
        })
    }

    handleProceedButtonClick = () => {
        let isError = false;
        if(isEmptyVariable(this.state.deadlineDate) && isEmptyVariable(this.state.selectedOption)){
            isError = true;
        }
        if(isError){
            this.setState({
                errorMsg:"Please select a date",
                showLoader:false
            });

            setTimeout(() => {
                this.setState({
                    formErrors:{},
                });
            },Constants.WRNG_MSG_TIMEOUT);
        }else{
            let deadlineDate = "";
            if(!isEmptyVariable(this.state.selectedOption)){
                const days = parseInt(this.state.selectedOption);
                deadlineDate = moment().add(days + 1, 'days').startOf('day').toISOString();
            }else{
                deadlineDate = moment(this.state.deadlineDate, 'YYYY-MM-DD').startOf('day').toISOString();
            }

            //call the fetch function
            fetch(Constants.SaveEmployeeOrAuditee,
            {
                method: "POST",
                mode:'cors',
                body: new URLSearchParams({
                    email:userDetails.email,
                    accessToken:userDetails.accessToken,
                    aeList:this.state.assignmentTasks,
                    assignmentId:this.props.assignmentId,
                    clientResponseDeadline:deadlineDate
                })
            })
            .then(response => { return response.json(); } )
            .then(data =>
            {
                if(handleTokenExpiry(data.responseCode)) return;
                else if(data.responseCode === Constants.CODE_SUCCESS){
                    this.handleDateDialogClose();
                    this.assignResourcesDialogClose();
                    this.handleClear();
                    this.unSelectAll();
                    this.getEmployeeOrAuditee();
                    this.setState({ dataChanged:true });
                }else{
                    this.handleClear();
                    this.setState({
                        showAlertDialogInfo:true,
                        alertDialogMessageInfo:data.responseMessage
                    })
                }
            });
        }
    }

    getEmployeeOrAuditee = () => {
        fetch(Constants.GetEmployeeOrAuditee+"/"+this.props.assignmentId,{
            method: "POST",
            mode:'cors',
            body: new URLSearchParams({
                email:userDetails.email,
                accessToken:userDetails.accessToken,
            })
        })
        .then(response => { return response.json(); } )
        .then(data =>
        {
            if(handleTokenExpiry(data.responseCode)) return;
            else if(data.responseCode === Constants.CODE_SUCCESS){
                let employeeData = data.data;
                let list = this.state.datalist;
                let datalistTemp = {};
                let assignedTasksMap = {};
                this.state.assignedTasks.forEach(item=>{
                    assignedTasksMap[item.taskId] = item;
                })
                Object.values(list).forEach((item)=>{
                    //add only leaf level nodes
                    if(this.state.processMap[item.processId] && !this.state.processMap[item.processId].hasChildren){
                        let updatedTaskList = [];
                        item.taskList.forEach(task=>{
                            if(!isEmptyVariable(assignedTasksMap[task.taskId])){
                                task.assigmentTaskStatus = assignedTasksMap[task.taskId].status;
                                task.assignmentTaskId = assignedTasksMap[task.taskId].assignmentTaskId;
                                task.showResponseWarning = assignedTasksMap[task.taskId].showResponseWarning;
                                task.employeeData = employeeData.filter(e => e.assignmentTaskId === task.assignmentTaskId);
                                if(!isEmptyArray(task.employeeData)){
                                    task.added = true;
                                    task.employeeFullName = task.employeeData[0].employeeDetails.firstName + " " + task.employeeData[0].employeeDetails.lastName + " ("+task.employeeData[0].employeeDetails.designation+")";
                                    task.employeeId = task.employeeData[0].employeeDetails.employeeId;
                                    task.employeeType = task.employeeData[0].userType;
                                    task.clientResponseDeadline = task.employeeData[0].clientResponseDeadline;
                                    task.hasAddedResponse = task.employeeData[0].hasAddedResponse;
                                    task.disabled = assignedTasksMap[task.taskId].allowClientReAssign === false;
                                } else {
                                    task.disabled = assignedTasksMap[task.taskId].allowClientReAssign === false;
                                }
                            } else {
                                task.disabled = false;
                            }
                            updatedTaskList.push(task);
                        })
                        item.taskList = updatedTaskList;

                        datalistTemp[item.processId] = item;
                        datalistTemp[item.processId].currentPageNo = 1; //set the current page no as 1 for all the individual task lists
                    }
                })
                this.setState({
                    employeeData:employeeData,
                    datalist:datalistTemp
                })
            }else{

            }
        })
    }
    /*******************API CALLS END HERE*******************/

    render() {
        return(
            <Router>
                {
                    this.state.componentDidMountFlag &&
                    <div className="m-t-10">
                        {
                            this.state.showLoader &&
                            <div class="loader"></div>
                        }
                        <div className="prev-next-layout">
                            <div className="flex-center-layout secondary-top-bar">
                                <div className="back-btn-layout" onClick={() => this.props.handleAssignForResponseDialogClose(this.state.dataChanged)}>
                                <span class="material-icons-outlined">arrow_back_ios</span>
                                </div>
                                <h6>{"Assign For Response"}</h6>
                            </div>
                            <div className="flex-center-layout">
                                <div style={{ marginRight: 10 }}>
                                    <FilterDropDown
                                        placeholder={this.state.FilterPlaceholder}
                                        dropdownArr={this.state.FilterDropDownArr}
                                        onDropDownItemClick={this.filterDropDownOnClick}
                                        themeSettings={themeSettings}
                                        name={"label"}
                                        dropdownWidth="200px"
                                    />
                                </div>
                                <div className="bordered-anchor"
                                style={{marginRight:5}}>
                                    <a onClick={this.unSelectAll} href="javascript:void(0);">
                                        <span class="material-icons-outlined">
                                        check_box_outline_blank
                                        </span>
                                        <p>Unselect All</p>
                                    </a>
                                </div>
                                <div className="bordered-anchor"
                                style={{marginRight:5}}>
                                    <a onClick={this.selectAll} href="javascript:void(0);">
                                        <span class="material-icons-outlined">
                                        check_box
                                        </span>
                                        <p>Select All</p>
                                    </a>
                                </div>
                                <AddNewButtonLayout themeSettings={themeSettings}
                                style={{marginRight:5}}>
                                    <a onClick={this.onClickRemoveFromAssignment} href="javascript:void(0);">
                                        <span className="material-icons">remove_circle_outline</span>
                                        <p>Remove</p>
                                    </a>
                                </AddNewButtonLayout>
                            
                                <AddNewButtonLayout themeSettings={themeSettings}>
                                    <a onClick={this.onClickAddToAssignment} href="javascript:void(0);">
                                        <span className="material-icons">add_circle</span>
                                        <p>Add for Response</p>
                                    </a>
                                </AddNewButtonLayout>
                            
                                <AddNewButtonLayout themeSettings={themeSettings} style={{marginLeft:5}}>
                                    <a onClick={this.onClickNextButton} href="javascript:void(0);">
                                        {/* <span className="material-icons">add_circle</span> */}
                                        <p>Next</p>
                                        <span class="material-icons-outlined">arrow_forward_ios</span>
                                    </a>
                                </AddNewButtonLayout>
                            </div>
                        </div>
                        <div className="assign-tasks-layout accordion-layout">
                            {
                                Object.values(isEmptyArray(this.state.filterDataList)?this.state.datalist:this.state.filterDataList).map((processObj,index)=>{
                                    let className;
                                    if (index === 0) {
                                        className = 'card-radius'; // CSS for the first item
                                    } else if (index === (Object.values(isEmptyArray(this.state.filterDataList)?
                                    this.state.datalist:this.state.filterDataList).length - 1)) {
                                        className = 'card-last'; // CSS for the last item
                                    } else {
                                        className = 'card-middle'; // CSS for all other items
                                    }
                                    return <div className="process-task-list">
                                        <Accordion style={{marginTop:index === 0?15:0}} activeKey={this.state.activeKey}>
                                            <Card className={className}> 
                                                <Card.Header>
                                                    <Accordion.Toggle
                                                        as={Button}
                                                        variant="link"
                                                        eventKey={processObj.processId}
                                                        onClick={() => this.handleAccordionToggle(processObj.processId)}
                                                    >
                                                        <div className='row align-items-center'>
                                                            <TableCheckBox onClick={this.handleStopPropagation}
                                                                themeSettings={themeSettings}>
                                                                <input
                                                                    type="checkbox"
                                                                    name={processObj.processId}
                                                                    id={processObj.processId}
                                                                    onChange={this.handleSelectionProcessTasks}
                                                                    disabled={isEmptyArray(processObj.taskList) || processObj.taskList.every(item => item.disabled)}
                                                                    checked={processObj.isProcSelected?true:false}
                                                                />
                                                                <label for={processObj.processId} 
                                                                style={{marginLeft:-3}}></label>
                                                            </TableCheckBox>
                                                            <h6 className='col-md-6 text-left'>{this.state.processMap[processObj.processId].breadCrumb}</h6>
                                                                {
                                                                    processObj.count > 0 &&
                                                                    <h6 className='col-md-2 text-left'>{"Total Task: "+processObj.count}</h6>
                                                                }
                                                            <h6 className='col-md-3 text-center'>{"Added to Assignment: "+processObj.taskList.filter(item => item.added == true).length}</h6>
                                                        </div>
                                                    </Accordion.Toggle>
                                                </Card.Header> 
                                                <Accordion.Collapse eventKey={processObj.processId}>
                                                    <Card.Body>
                                                        {
                                                            !isEmptyArray(processObj.taskList) && 
                                                            <div className="common-tab-bg">
                                                                <div class="common-table" style={{width: "100%", borderRadius: "4px"}}>
                                                                    <div className="table-custom-layout">
                                                                        <div className="table-custom-header">
                                                                            <div className="table-custom-header-row">
                                                                                <p style={{width:"5%"}}></p>
                                                                                <p style={{width:"5%",justifyContent:"center"}}>No</p>
                                                                                <p style={{width:"42%"}}>Task</p>
                                                                                <p style={{width:"25%"}}>Employee</p>
                                                                                <p style={{width:"15%"}}>Response Deadline</p>
                                                                                <p style={{width:"8%"}}>Added</p>
                                                                                
                                                                            </div>
                                                                        </div>
                                                                        
                                                                        <div className="table-custom-body">
                                                                        {
                                                                            !isEmptyArray(processObj.taskList) && 
                                                                            processObj.taskList.map((item,idx) => {
                                                                                let spanObj = getStatusSpan(item.assigmentTaskStatus,themeSettings);
                                                                                const isLastRow = idx === processObj.taskList.length - 1;
                                                                                return <CustomTableRow themeSettings={themeSettings}
                                                                                className={item.disabled?"row-disable":""}>
                                                                                    <div className="table-cell" style={{width:"5%"}}>
                                                                                        <TableCheckBox onClick={this.handleStopPropagation}
                                                                                            themeSettings={themeSettings}>
                                                                                            <input 
                                                                                                type="checkbox"
                                                                                                name={idx+":-:"+processObj.processId}
                                                                                                id={idx+":-:"+item.taskId}
                                                                                                onChange={this.handleSelectionTask}
                                                                                                disabled={item.disabled}
                                                                                                checked={item.isSelected?true:false}
                                                                                            />
                                                                                            <label for={idx+":-:"+item.taskId} 
                                                                                            style={{marginLeft:6}}></label>
                                                                                        </TableCheckBox>
                                                                                    </div>
                                                                                    <p style={{width:"5%",justifyContent:"center"}}>{(idx+1)}</p>
                                                                                    <p style={{width:"42%"}}>
                                                                                        {/* {removeHtmlTags(item.task)} */}
                                                                                        <div className='task-dangerouslysethtml' dangerouslySetInnerHTML={{__html: item.task}} />
                                                                                        {
                                                                                            item.completionStatus==="Completed" &&
                                                                                            <span style={{marginLeft:6}}className="material-icons">done_all</span>
                                                                                        }
                                                                                        {
                                                                                            !isEmptyVariable(spanObj.spanText) &&
                                                                                            <span style={spanObj.spanStyle} className="span-tag">
                                                                                                {spanObj.spanText}
                                                                                            </span>
                                                                                        }
                                                                                        {
                                                                                            item.showResponseWarning &&
                                                                                            <span className={"tool"+(isLastRow?" tool-top":"")} data-title="Client has responded on the task."
                                                                                                style={{marginLeft:6, verticalAlign:"middle", cursor:"pointer"}}>
                                                                                                <span className="material-icons" style={{fontSize:18, verticalAlign:"middle"}}>done_all</span>
                                                                                            </span>
                                                                                        }
                                                                                    </p>
                                                                                    <p style={{width:"25%"}}>
                                                                                        {isEmptyArray(item.employeeData)?"":
                                                                                            item.employeeData[0]?.employeeDetails?.firstName+" "+item.employeeData[0]?.employeeDetails?.lastName+" ("+item.employeeData[0]?.employeeDetails?.designation+")"
                                                                                        }
                                                                                    </p>
                                                                                    <p style={{width:"15%"}}>
                                                                                        {(() => {
                                                                                            const deadlineBadge = item.hasAddedResponse ? null : getClientResponseDeadlineBadge(item.clientResponseDeadline);
                                                                                            return deadlineBadge ? (
                                                                                                <div className={"tool"+(isLastRow?" tool-top":"")} data-title={deadlineBadge.tooltip}
                                                                                                    style={{
                                                                                                        display:"inline-block",
                                                                                                        padding:"1px 8px",
                                                                                                        borderRadius:12,
                                                                                                        fontSize:11, fontWeight:600, whiteSpace:"nowrap",
                                                                                                        background:deadlineBadge.bgColor, color:deadlineBadge.textColor
                                                                                                    }}>
                                                                                                    {deadlineBadge.text}
                                                                                                </div>
                                                                                            ) : "-";
                                                                                        })()}
                                                                                    </p>
                                                                                    <p style={{width:"8%"}}>
                                                                                        {
                                                                                            item.added &&
                                                                                            <span class="material-icons"
                                                                                            style={{color:`rgba(${themeSettings.themeColor.r},${themeSettings.themeColor.g},${themeSettings.themeColor.b},${themeSettings.themeColor.a})`}}>check_circle</span>
                                                                                        }
                                                                                    </p>
                                                                                    
                                                                                </CustomTableRow>
                                                                            })
                                                                        }
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        }
                                                    </Card.Body>
                                                </Accordion.Collapse>
                                            </Card>
                                        </Accordion>
                                        {
                                            this.state.componentDidMountFlag && isEmptyArray(processObj.taskList) &&
                                            <div class="no-items-layout">
                                                <div class="no-items-card" style={{padding:"10px"}}>
                                                    <h6 style={{margin:0}}>
                                                    {
                                                        Constants.NO_RECORDS_WARNING
                                                    }
                                                    </h6>
                                                </div>
                                            </div>
                                        }
                                    </div>
                                })
                            }
                        </div>
                    </div>
                }
                <AlertDialog
                    showAlertDialog={this.state.showAlertDialogInfo}
                    handleAlertDialogClose={this.handleAlertDialogCloseInfo}
                    type={Constants.ALERT_TYPE_ALERT}
                    alertDialogMessage={this.state.alertDialogMessageInfo}
                    proceedBtnClick={this.handleAlertDialogCloseInfo}
                    proceedBtnLabel={Constants.ALERT_TYPE_OKAY_LABEL}
                    themeSettings={themeSettings}
                />
                <AlertDialog
                    showAlertDialog={this.state.showResponseWarningDialog}
                    handleAlertDialogClose={this.handleResponseWarningDialogClose}
                    type={Constants.ALERT_TYPE_WARNING}
                    alertDialogHeading={"Response Already Received"}
                    alertDialogMessage={this.state.responseWarningMessage}
                    proceedBtnClick={this.addSelectedToAssignment}
                    proceedBtnLabel={"Yes"}
                    themeSettings={themeSettings}
                />
                <AlertDialog
                    showAlertDialog={this.state.showResourceResponseWarningDialog}
                    handleAlertDialogClose={this.handleResourceResponseWarningDialogClose}
                    type={Constants.ALERT_TYPE_WARNING}
                    alertDialogHeading={"Response Already Received"}
                    alertDialogMessage={this.state.resourceResponseWarningMessage}
                    proceedBtnClick={this.handleResourceResponseWarningConfirm}
                    proceedBtnLabel={"Yes"}
                    themeSettings={themeSettings}
                />
                <Modal className="task-select-table-dialog custom-dialog"
                    show={this.state.showAssignResourcesDialogFlag}
                    backdrop="static">
                    <Modal.Header>
                        <h5>Assign Client</h5>
                        <button 
                            onClick={this.assignResourcesDialogClose}
                            type="button" data-dismiss="modal">
                            <span class="material-icons">close</span>
                        </button>
                    </Modal.Header>
                    <hr />
                    <div className="modal-body">
                        <div className="body-wrapper">
                            <div className="search-addnew-bg" style={{marginTop:0}}>
                                <div className="search-addnew">
                                    <div className="flex-center-layout">
                                        <div style={{ marginRight: 10 }}>
                                            <FilterDropDown
                                                placeholder={this.state.assignResourcesPlaceholder}
                                                dropdownArr={this.state.assigneResourcesFilterDropDownArr}
                                                onDropDownItemClick={this.assigneResourceFilterDropDownOnClick}
                                                themeSettings={themeSettings}
                                                name={"label"}
                                                dropdownWidth="200px"
                                            />
                                        </div>
                                        <div className="bordered-anchor"
                                        style={{marginRight:5}}>
                                            <a onClick={this.unSelectAllTasksResourcesDialog} href="javascript:void(0);">
                                                <span class="material-icons-outlined">
                                                check_box_outline_blank
                                                </span>
                                                <p>Unselect All</p>
                                            </a>
                                        </div>
                                        <div className="bordered-anchor"
                                        style={{marginRight:5}}>
                                            <a onClick={this.selectAllTasksResourcesDialog} href="javascript:void(0);">
                                                <span class="material-icons-outlined">
                                                check_box
                                                </span>
                                                <p>Select All</p>
                                            </a>
                                        </div>
                                        <div style={{width:"300px"}}>
                                            <AsyncPaginate
                                                key={this.state.employeeSelectKey}
                                                value={this.state.selectedEmployee}
                                                loadOptions={this.getEmployeesList}
                                                defaultOptions={false}
                                                cacheOptions={false}
                                                placeholder="Search Employee..."
                                                getOptionLabel={(e) => e.fullName}
                                                getOptionValue={(e) => e.employeeId}
                                                onChange={this.handleEmployeeSelect}
                                                noOptionsMessage={({ inputValue }) =>
                                                    inputValue && inputValue.length >= 3 ? "No employees found" : "Type at least 3 characters to search"
                                                }
                                                formatOptionLabel={(emp, { context }) => {
                                                    if(context === "value") return <span>{emp.fullName}</span>;
                                                    return (
                                                        <div style={{display:"flex", alignItems:"center", justifyContent:"space-between"}}>
                                                            <span style={{flex:1, marginRight:"8px"}}>{emp.fullName}</span>
                                                            {emp.isAuditee && (
                                                                <span style={{
                                                                    fontSize:"10px", fontWeight:"600",
                                                                    color:`rgba(${themeSettings.themeColor.r},${themeSettings.themeColor.g},${themeSettings.themeColor.b},${themeSettings.themeColor.a})`,
                                                                    border:`1px solid rgba(${themeSettings.themeColor.r},${themeSettings.themeColor.g},${themeSettings.themeColor.b},${themeSettings.themeColor.a})`,
                                                                    borderRadius:"10px", padding:"1px 7px",
                                                                    whiteSpace:"nowrap", flexShrink:0
                                                                }}>Auditee</span>
                                                            )}
                                                        </div>
                                                    );
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div>
                                        <DialogSaveButton themeSettings={themeSettings} 
                                        onClick={this.onClickAddResourceToAssignment} type="button" 
                                        className="modal-save m-b-0">Assign</DialogSaveButton>
                                    </div>
                                </div>       
                            </div>
                            <div className="assign-taskresource accordion-layout" style={{position:"relative"}}>
                                {Object.values(isEmptyArray(this.state.assigneResourcesFilterDataList)?this.state.datalist:this.state.assigneResourcesFilterDataList)
                                .filter(processObj => processObj.taskList.some((item) => item.added === true))
                                .map((processObj,index)=>{
                                    let showTasks = false;
                                    let className;
                                    if (index === 0) {
                                        className = 'card-radius'; // CSS for the first item
                                    } else if (index === ((Object.values(isEmptyArray(this.state.assigneResourcesFilterDataList)?
                                        this.state.datalist:this.state.assigneResourcesFilterDataList))
                                        .filter(processObj => processObj.taskList.some((item) => item.added===true))).length - 1) {
                                        className = 'card-last'; // CSS for the last item
                                    } else {
                                        className = 'card-middle'; // CSS for all other items
                                    }
                                    
                                    // showTasks=!!processObj.taskList.find(({added}) =>added===true)
                                    showTasks=processObj.taskList.some((item) =>item.added===true)
                                    const addedTasksInProc = processObj.taskList.filter(item => item.added===true);
                                    const allAddedDisabled = addedTasksInProc.every(item => item.disabled);
                                    if(showTasks){
                                        return <div className="process-task-list">
                                            <Accordion style={{marginTop:index === 0?15:0}} activeKey={this.state.activeAssignResourceKey}>
                                                <Card className={className}> 
                                                    <Card.Header>
                                                        <Accordion.Toggle
                                                            as={Button}
                                                            variant="link"
                                                            eventKey={processObj.processId}
                                                            onClick={() => this.handleAccordionToggleAssignResource(processObj.processId)}
                                                        >
                                                            <div className='row align-items-center'>
                                                                <TableCheckBox
                                                                    themeSettings={themeSettings}>
                                                                    <input
                                                                        type="checkbox"
                                                                        name={processObj.processId}
                                                                        id={"RES"+processObj.processId}
                                                                        onChange={this.handleSelectionProcessTasksInResourcesDialog}
                                                                        disabled={allAddedDisabled}
                                                                        checked={processObj.isProcSelectedInResources?true:false}
                                                                    />
                                                                    <label for={"RES"+processObj.processId} 
                                                                    style={{marginLeft:5}}></label>
                                                                </TableCheckBox> 
                                                                <h6 className='col-md-6 text-left'>{this.state.processMap[processObj.processId].breadCrumb}</h6>
                                                                {
                                                                    processObj.taskList.filter(item => item.added === true).length > 0 &&
                                                                    <h6 className='col-md-2 text-left'>{"Total Task: "+processObj.taskList.filter(item => item.added === true).length}</h6>
                                                                }
                                                                <h6 className='col-md-3 text-center'>{"Employee Assigned: "+processObj.taskList.filter(taskItem => !isEmptyVariable(taskItem.employeeFullName)).length}</h6>
                                                            </div>
                                                        </Accordion.Toggle>
                                                    </Card.Header> 
                                                    <Accordion.Collapse eventKey={processObj.processId}>
                                                        <Card.Body>                                            
                                                            {
                                                                !isEmptyArray(processObj.taskList) && 
                                                                <div className="common-tab-bg">
                                                                    <div className="common-table" style={{width:"100%"}}>
                                                                        <table className="table">
                                                                            <thead>
                                                                                <tr>
                                                                                    <th className="text-center" width={"8%"}></th>
                                                                                    <th className="text-center" width={"5%"}>No.</th>
                                                                                    <th width={"55%"}>Tasks</th>
                                                                                    <th width={"33%"}>Employees</th>
                                                                                </tr>
                                                                            </thead>
                                                                            <tbody>
                                                                            {
                                                                                !isEmptyArray(processObj.taskList) &&
                                                                                (totalAdded => (visibleRowNo => processObj.taskList.map((item,idx) => {
                                                                                    if(item.added){
                                                                                        visibleRowNo++;
                                                                                        const isLastVisible = visibleRowNo === totalAdded;
                                                                                        return <tr className={item.disabled?"row-disable":""}>
                                                                                            <td>
                                                                                                <TableCheckBox
                                                                                                    themeSettings={themeSettings}>
                                                                                                    <input
                                                                                                        type="checkbox"
                                                                                                        name={idx+":-:"+processObj.processId}
                                                                                                        id={idx+":-:"+"RES"+item.taskId}
                                                                                                        onChange={this.handleSelectionTaskInResourcesDialog}
                                                                                                        disabled={item.disabled}
                                                                                                        checked={item.isEmployeeTaskSelected?true:false}
                                                                                                    />
                                                                                                    <label for={idx+":-:"+"RES"+item.taskId}
                                                                                                    style={{marginLeft:6}}></label>
                                                                                                </TableCheckBox>
                                                                                            </td>
                                                                                            <td className="text-center">{visibleRowNo}</td>
                                                                                            <td>
                                                                                                <div className="flex-center-layout">
                                                                                                {removeHtmlTags(item.task)}
                                                                                                {
                                                                                                    item.completionStatus==="Completed" &&
                                                                                                    <span style={{marginLeft:6,fontSize:18}}
                                                                                                    className="material-icons">done_all</span>
                                                                                                }
                                                                                                {
                                                                                                    item.showResponseWarning &&
                                                                                                    <span className={"tool"+(isLastVisible?" tool-top":"")} data-title="Client has responded on the task."
                                                                                                        style={{marginLeft:6, verticalAlign:"middle", cursor:"pointer"}}>
                                                                                                        <span className="material-icons" style={{fontSize:18, verticalAlign:"middle"}}>done_all</span>
                                                                                                    </span>
                                                                                                }
                                                                                                </div>
                                                                                            </td>
                                                                                            {/* <td>{isEmptyArray(item.employeeData)?"":
                                                                                                item.employeeData[0]?.employeeDetails?.firstName+" "+item.employeeData[0]?.employeeDetails?.lastName+" ("+item.employeeData[0]?.employeeDetails?.designation+")"
                                                                                            }</td> */}
                                                                                            <td>{isEmptyVariable(item.employeeFullName)?"":item.employeeFullName}</td>
                                                                                        </tr>
                                                                                    }
                                                                                }))(0))(processObj.taskList.filter(t => t.added).length)
                                                                            }
                                                                            </tbody>
                                                                        </table>
                                                                    </div>
                                                                </div>
                                                            }
                                                        </Card.Body>
                                                    </Accordion.Collapse>
                                                </Card>
                                            </Accordion>
                                        </div>
                                    }
                                })
                            }
                            </div>
                        </div>
                    </div>
                </Modal>

                <Modal className="custom-dialog" show={this.state.showNextDateDialog} backdrop="static">
                    <Modal.Header>
                        <h5>{"Response Deadline Date"}</h5>
                        <button 
                            onClick={this.handleDateDialogClose}
                            type="button" data-dismiss="modal">
                            <span class="material-icons">close</span>
                        </button>
                    </Modal.Header>
                    <div class="modal-body">
                        <div className="addnew-modal-form">
                            <div class="addnew-modal-form-group">
                                <DatePicker
                                    onChange={this.onDateChange}
                                    value={!isEmptyVariable(this.state.deadlineDate)?moment(this.state.deadlineDate):null}
                                    format={"DD/MM/YYYY"}
                                    placeholder="Select Date"
                                    disabledDate={(current) => current.isSameOrBefore(moment(), "day")}
                                    // selectedItem={!isEmptyVariable(this.state.deadlineDate)?moment(this.state.deadlineDate):""}
                                    disabled={!isEmptyVariable(this.state.selectedOption)} // disable when radio selected
                                />
                            </div>
                            <div className='addnew-modal-form-group'>
                                <div className="radio-group radio-group-inline">
                                    <div style={{display: "flex", flexDirection: "row", gap: "20px", alignItems: "center"}}>
                                        <TableRadioButton
                                            key={'7'}
                                            style={{marginLeft:0, display:"flex", flexDirection: "column", alignItems: "center"}}
                                            themeSettings={themeSettings}
                                        >
                                            <input 
                                                type="radio"
                                                name="7"
                                                id={'7'}
                                                value={'7'}
                                                onChange={this.handleCheck}
                                                checked={this.state.selectedOption === "7"}
                                                disabled={!isEmptyVariable(this.state.deadlineDate)}
                                            />
                                            <label htmlFor={'7'} style={{marginLeft:0}}>7 Days</label>
                                        </TableRadioButton>
                                        <TableRadioButton
                                            key={'10'}
                                            style={{marginLeft:0, display:"flex", flexDirection: "column", alignItems: "center"}}
                                            themeSettings={themeSettings}
                                        >
                                            <input 
                                                type="radio"
                                                name="10"
                                                id={'10'}
                                                value={'10'}
                                                onChange={this.handleCheck}
                                                checked={this.state.selectedOption === "10"}
                                                disabled={!isEmptyVariable(this.state.deadlineDate)}
                                            />
                                            <label htmlFor={'10'} style={{marginLeft:0}}>10 Days</label>
                                        </TableRadioButton>
                                        <TableRadioButton
                                            key={'15'}
                                            style={{marginLeft:0, display:"flex", flexDirection: "column", alignItems: "center"}}
                                            themeSettings={themeSettings}
                                        >
                                            <input 
                                                type="radio"
                                                name="15"
                                                id={'15'}
                                                value={'15'}
                                                onChange={this.handleCheck}
                                                checked={this.state.selectedOption === "15"}
                                                disabled={!isEmptyVariable(this.state.deadlineDate)}
                                            />
                                            <label htmlFor={'15'} style={{marginLeft:0}}>15 Days</label>
                                        </TableRadioButton>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {
                            this.state.errorMsg &&
                            <span className="cm-error dialog-error">{this.state.errorMsg}</span>
                        }

                        <div class="dialog-btn-layout">
                            <a class="alert-cancel" href="javascript:void(0);"
                                onClick={this.handleDateDialogClose}
                            >Cancel</a>
                            <a class="alert-cancel" href="javascript:void(0);"
                                onClick={this.handleClear}
                                style={{
                                    marginLeft:"10px"
                                }}
                            >Clear</a>
                            <DialogProceedButton
                                themeSettings={themeSettings}
                                class="alert-proceed"
                                href="javascript:void(0);"
                                onClick={this.handleProceedButtonClick}
                                style={{
                                    marginLeft:"10px"
                                }}
                            >
                                {this.state.showLoader ? <div class="loader-btn mt-2"></div> : "Save"}
                            </DialogProceedButton>
                        </div>
                    </div>
                </Modal>
            </Router>
        );
    }
}

export default AssignForResponse;